// main.js

import cadastro from './cadastro'

export default {
  system: {
    ...cadastro
  }
}
